module.exports = __webpack_public_path__ + "img/BackCover.67bf9f40.jpg";